import Logo from "../common/logo";
import MenuPrincipal from "./menu-principal";
import SectionPage from "@/components/common/section-page";
import {cn} from "@/lib/utils";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"


export default function HeaderEspacePro() {
    return <header className="px-6 py-2 gap-8 h-[412px] flex flex-col gap relative">
        <div className={"bg-espaceProHeader bg-cover w-full h-full absolute top-0 left-0"}></div>
        <div className={"bg-gray-400 bg-opacity-60 w-full h-full absolute top-0 left-0"}></div>

        <SectionPage className={"flex flex-col relative w-full"} sectionType={"xl"}>
            <Logo />
            <div className={cn("bg-rouge w-full p-4 rounded-lg flex justify-between items-center")}>
                <span className={"font-playfair-display italic text-2xl font-bold text-white"}>Espace Pro</span>
                <MenuPrincipal />
            </div>
        </SectionPage>

        <SectionPage className={"flex flex-col relative w-full"} sectionType={"lg"}>
            <div className={"font-playfair-display italic text-4xl font-bold text-white mb-8"}>Espace Pro</div>
            <Breadcrumb className={"text-white"}>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="/" className={"text-white opacity-60"}>Accueil</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator className={"text-white"} />
                    <BreadcrumbItem>
                        <BreadcrumbPage className={"font-bold text-white"}>Espace pro</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>

        </SectionPage>
    </header>;
}
